import Components from "@alboom/custom-page-components/components";

const getElementVersions = elementName => {
  const target = Components[elementName];
  const ret = {};
  Object.keys(target).forEach(version => {
    const elementManifest = target[version].manifest;
    ret[version] = elementManifest.version;
  });
  return ret;
};

export default getElementVersions;
